/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * sim_jizen.csvのデータ（放流情報）
 * @export
 * @interface DischargeInfoData
 */
export interface DischargeInfoData {
    /**
     * ダムコード
     * @type {string}
     * @memberof DischargeInfoData
     */
    damCode?: string;
    /**
     * ダム名
     * @type {string}
     * @memberof DischargeInfoData
     */
    damName?: string;
    /**
     * 基準雨量タイトル
     * @type {string}
     * @memberof DischargeInfoData
     */
    basinAveRainTitle?: string;
    /**
     * 継続時間（ダム）
     * @type {number}
     * @memberof DischargeInfoData
     */
    conTimeDam?: number;
    /**
     * 流域平均雨量限界（ダム）
     * @type {number}
     * @memberof DischargeInfoData
     */
    basinAveRainLimDam?: number;
    /**
     * 流域平均雨量GSMGD（ダム）
     * @type {number}
     * @memberof DischargeInfoData
     */
    basinAveRainGsmgdDam?: number;
    /**
     * 予測時刻GSMGD
     * @type {string}
     * @memberof DischargeInfoData
     */
    forecastTimeGsmgd?: string;
    /**
     * 更新時刻GSMGD
     * @type {string}
     * @memberof DischargeInfoData
     */
    updateTimeGsmgd?: string;
    /**
     * 流域平均雨量MSMGD（ダム）
     * @type {number}
     * @memberof DischargeInfoData
     */
    basinAveRainMsmgdDam?: number;
    /**
     * 予測時刻MSMGD
     * @type {string}
     * @memberof DischargeInfoData
     */
    forecastTimeMsmgd?: string;
    /**
     * 更新時刻MSMGD
     * @type {string}
     * @memberof DischargeInfoData
     */
    updateTimeMsmgd?: string;
    /**
     * 基準点名
     * @type {string}
     * @memberof DischargeInfoData
     */
    basePointName?: string;
    /**
     * 継続時間
     * @type {number}
     * @memberof DischargeInfoData
     */
    conTime?: number;
    /**
     * 基準雨量限界
     * @type {number}
     * @memberof DischargeInfoData
     */
    baseRainLim?: number;
    /**
     * 基準FR48
     * @type {number}
     * @memberof DischargeInfoData
     */
    baseFR48?: number;
    /**
     * 流域平均雨量限界
     * @type {number}
     * @memberof DischargeInfoData
     */
    basinAveRainLim?: number;
    /**
     * 基準FR72-FR24
     * @type {number}
     * @memberof DischargeInfoData
     */
    baseFR72FR24?: number;
    /**
     * 流域平均雨量GSMGD
     * @type {number}
     * @memberof DischargeInfoData
     */
    basinAveRainGsmgd?: number;
    /**
     * 流域平均雨量MSMGD
     * @type {number}
     * @memberof DischargeInfoData
     */
    basinAveRainMsmgd?: number;
    /**
     * 予測時刻JMA
     * @type {string}
     * @memberof DischargeInfoData
     */
    forecastTimeJMA?: string;
    /**
     * 追加通知
     * @type {string}
     * @memberof DischargeInfoData
     */
    extraNotice?: string;
    /**
     * 事前洪水調節容量
     * @type {number}
     * @memberof DischargeInfoData
     */
    preFloodControlVol?: number;
    /**
     * 空き容量
     * @type {number}
     * @memberof DischargeInfoData
     */
    freeVol?: number;
    /**
     * 不足容量
     * @type {number}
     * @memberof DischargeInfoData
     */
    shortVol?: number;
    /**
     * 事前水位
     * @type {number}
     * @memberof DischargeInfoData
     */
    preStage?: number;
    /**
     * 事前放流量
     * @type {number}
     * @memberof DischargeInfoData
     */
    preDischarge?: number;
    /**
     * 事前判断
     * @type {boolean}
     * @memberof DischargeInfoData
     */
    preDecision?: boolean;
}

/**
 * Check if a given object implements the DischargeInfoData interface.
 */
export function instanceOfDischargeInfoData(value: object): value is DischargeInfoData {
    return true;
}

export function DischargeInfoDataFromJSON(json: any): DischargeInfoData {
    return DischargeInfoDataFromJSONTyped(json, false);
}

export function DischargeInfoDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DischargeInfoData {
    if (json == null) {
        return json;
    }
    return {
        
        'damCode': json['damCode'] == null ? undefined : json['damCode'],
        'damName': json['damName'] == null ? undefined : json['damName'],
        'basinAveRainTitle': json['basinAveRainTitle'] == null ? undefined : json['basinAveRainTitle'],
        'conTimeDam': json['conTimeDam'] == null ? undefined : json['conTimeDam'],
        'basinAveRainLimDam': json['basinAveRainLimDam'] == null ? undefined : json['basinAveRainLimDam'],
        'basinAveRainGsmgdDam': json['basinAveRainGsmgdDam'] == null ? undefined : json['basinAveRainGsmgdDam'],
        'forecastTimeGsmgd': json['forecastTimeGsmgd'] == null ? undefined : json['forecastTimeGsmgd'],
        'updateTimeGsmgd': json['updateTimeGsmgd'] == null ? undefined : json['updateTimeGsmgd'],
        'basinAveRainMsmgdDam': json['basinAveRainMsmgdDam'] == null ? undefined : json['basinAveRainMsmgdDam'],
        'forecastTimeMsmgd': json['forecastTimeMsmgd'] == null ? undefined : json['forecastTimeMsmgd'],
        'updateTimeMsmgd': json['updateTimeMsmgd'] == null ? undefined : json['updateTimeMsmgd'],
        'basePointName': json['basePointName'] == null ? undefined : json['basePointName'],
        'conTime': json['conTime'] == null ? undefined : json['conTime'],
        'baseRainLim': json['baseRainLim'] == null ? undefined : json['baseRainLim'],
        'baseFR48': json['baseFR48'] == null ? undefined : json['baseFR48'],
        'basinAveRainLim': json['basinAveRainLim'] == null ? undefined : json['basinAveRainLim'],
        'baseFR72FR24': json['baseFR72-FR24'] == null ? undefined : json['baseFR72-FR24'],
        'basinAveRainGsmgd': json['basinAveRainGsmgd'] == null ? undefined : json['basinAveRainGsmgd'],
        'basinAveRainMsmgd': json['basinAveRainMsmgd'] == null ? undefined : json['basinAveRainMsmgd'],
        'forecastTimeJMA': json['forecastTimeJMA'] == null ? undefined : json['forecastTimeJMA'],
        'extraNotice': json['extraNotice'] == null ? undefined : json['extraNotice'],
        'preFloodControlVol': json['preFloodControlVol'] == null ? undefined : json['preFloodControlVol'],
        'freeVol': json['freeVol'] == null ? undefined : json['freeVol'],
        'shortVol': json['shortVol'] == null ? undefined : json['shortVol'],
        'preStage': json['preStage'] == null ? undefined : json['preStage'],
        'preDischarge': json['preDischarge'] == null ? undefined : json['preDischarge'],
        'preDecision': json['preDecision'] == null ? undefined : json['preDecision'],
    };
}

export function DischargeInfoDataToJSON(json: any): DischargeInfoData {
    return DischargeInfoDataToJSONTyped(json, false);
}

export function DischargeInfoDataToJSONTyped(value?: DischargeInfoData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'damCode': value['damCode'],
        'damName': value['damName'],
        'basinAveRainTitle': value['basinAveRainTitle'],
        'conTimeDam': value['conTimeDam'],
        'basinAveRainLimDam': value['basinAveRainLimDam'],
        'basinAveRainGsmgdDam': value['basinAveRainGsmgdDam'],
        'forecastTimeGsmgd': value['forecastTimeGsmgd'],
        'updateTimeGsmgd': value['updateTimeGsmgd'],
        'basinAveRainMsmgdDam': value['basinAveRainMsmgdDam'],
        'forecastTimeMsmgd': value['forecastTimeMsmgd'],
        'updateTimeMsmgd': value['updateTimeMsmgd'],
        'basePointName': value['basePointName'],
        'conTime': value['conTime'],
        'baseRainLim': value['baseRainLim'],
        'baseFR48': value['baseFR48'],
        'basinAveRainLim': value['basinAveRainLim'],
        'baseFR72-FR24': value['baseFR72FR24'],
        'basinAveRainGsmgd': value['basinAveRainGsmgd'],
        'basinAveRainMsmgd': value['basinAveRainMsmgd'],
        'forecastTimeJMA': value['forecastTimeJMA'],
        'extraNotice': value['extraNotice'],
        'preFloodControlVol': value['preFloodControlVol'],
        'freeVol': value['freeVol'],
        'shortVol': value['shortVol'],
        'preStage': value['preStage'],
        'preDischarge': value['preDischarge'],
        'preDecision': value['preDecision'],
    };
}

